import { atom } from "recoil";

export const textLangState = atom({
  key: "textLangState",
  default: "lat",
});
